import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

export default function Statistic({ label, value, iconBackgroundColor }) {
  return (
    <Row className="justify-content-between align-items-center mt-2">
      <Col className="fw-semibold">
        <div className="icon-with-text">
          <i
            className="dot-icon"
            style={{ backgroundColor: iconBackgroundColor, minWidth: '1rem', minHeight: '1rem' }}
          />
          <span className="text-content">
            {label}
          </span>
        </div>
      </Col>

      <Col xs="auto" className="fw-light">
        {value}
        %
      </Col>
    </Row>
  );
}

Statistic.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
  iconBackgroundColor: PropTypes.string.isRequired,
};

Statistic.defaultProps = {
  value: 0,
};
